import type { UserSummary } from '@/lib/api/generated/model';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { discardDraftQuestion } from '../builder/draftCopy';

/**
 * Confirms throwing a published workflow's draft away (spec 144 FR-006).
 *
 * The draft is shared (Q6), so the one thing the question must carry is whose
 * work it is and when it was saved: "the draft" alone would let someone
 * discard a colleague's afternoon believing it was their own five minutes.
 */
export function DiscardDraftDialog({
  savedBy,
  savedAt,
  open,
  isPending,
  onOpenChange,
  onConfirm,
}: {
  savedBy: UserSummary | null;
  savedAt: string;
  open: boolean;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (isPending) return;
        onOpenChange(next);
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{discardDraftQuestion(savedBy, savedAt)}</DialogTitle>
          <DialogDescription>
            The published version stays as it is.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose
            render={<Button variant="outline" disabled={isPending} />}
          >
            Cancel
          </DialogClose>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            Discard draft
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
